import React from 'react'
import { useParams } from 'react-router-dom';
import { host } from '../axiosInterceptor';

function ViewPDF({ path = ""}) {

  const params = useParams();

  return (
    <div style={{height:"100%"}} className='pt-2'>

      <embed
        id='pdfViewer' 
        src={`${host}/${path}/${params.id_sentence}.pdf`} 
        type="application/pdf" 
        style={{ height: '99%', width: '100%' }} 
      />

    </div>
  )
}

export default ViewPDF